const Main = () => import("@/views/Main.vue");

const financeRouter = {
  path: "/finance",
  name: "Finance",
  component: Main,
  icon: require(`@/assets/images/menu-icons/icon_finance_20_20.png`),
  icon_active: require(`@/assets/images/menu-icons/icon_finance_hover_20_20.png`),
  children: [
    {
      path: "deposit",
      name: "MarginManage",
      component: () => import("@/views/Financial/MarginManage.vue"),
      meta: {
        title: "保证金管理",
        roles: ["deposit"]
      }
    },
    {
      path: "waybill-payment-record",
      name: "OrderPayment",
      component: () => import("@/views/Financial/OrderPayment.vue"),
      meta: {
        title: "订单支付记录",
        roles: ["waybill-payment-record"]
      }
    },
    {
      path: "driver-withdraw",
      name: "DriverWithdrawal",
      component: () => import("@/views/Financial/DriverWithdrawal.vue"),
      meta: {
        title: "司机提现审核",
        roles: ["driver-withdraw"]
      }
    },
    {
      path: "driver-account",
      name: "DriverAccount",
      component: () => import("@/views/Financial/DriverAccount.vue"),
      meta: {
        title: "司机帐户余额",
        roles: ["driver-account"]
      }
    },
    {
      path: "shipper-invest-record",
      name: "ShipperInvestRecord",
      component: () => import("@/views/Financial/ShipperInvestRecord.vue"),
      meta: {
        title: "货主充值记录",
        roles: ["shipper-invest-record"]
      }
    },
    {
      path: "owner-account-balance",
      name: "OwnerAccountBalance",
      component: () => import("@/views/Financial/OwnerAccountBalance.vue"),
      meta: {
        title: "货主账户余额",
        roles: ["owner-account-record"]
      }
    },
    {
      path: "driver-member-recharge-record",
      name: "driverMemberRechargeRecord",
      component: () => import("@/views/Financial/driverMemberRechargeRecord.vue"),
      meta: {
        title: "司机充值记录",
        roles: ["driver-member-record"]
      }
	},{
		path: "/finance/coupon-query", 
		name: "CouponQuery",
    component: () => import("@/views/Financial/AddCoupons.vue"),
    hidden: true,
		meta: {
			title: "优惠券查询",
			roles: ["coupon-query"]
		}
	},
	{
        path: 'coupon-manager',
        name: 'CouponManager',
        component: () => import('@/views/Report/CouponManager.vue'),
        meta: {
            title: '优惠券管理',
            roles: ['coupon-manager']
		},
		children: [
			{
				path: "/finance/coupon-query", 

				name: "CouponQuery",
				meta: {
					title: "优惠券查询",
					
				}
			},
		]
	},
    {
      path: "invoice-manager",
      name: "invoiceManager",
      component: () => import("@/views/Financial/invoiceManager.vue"),
      meta: {
        title: "发票管理",
        roles: ["driver-member-record"]
      }
    }
    
  ],
  meta: {
    title: "财务管理",
    roles: ["finance"]
  }
};

export default financeRouter;
